import React, { useEffect, useState } from 'react';
import { FC } from 'react';
import { Wrapper } from './EducationQualityManagementSystem.elements';

export const EDUCATION_QUALITY_MANAGEMENT_SYSTEM_ID = 'EducationQualityManagementSystem';

export interface EducationQualityManagementSystemProps { }

const EducationQualityManagementSystemTemplate: FC<EducationQualityManagementSystemProps> = () => {
    return (
        <Wrapper>


            <div className="title" id={`${EDUCATION_QUALITY_MANAGEMENT_SYSTEM_ID}-sekcia`}>
                Interná smernica riadenia a zabezpečovania kvality vzdelávania
            </div>
            <div className="subTitle">
                Poradca podnikateľa, s. r. o. – úsek Vzdelávanie, platforma Profivzdelávanie.sk
            </div>




          
            <h1 className="sectionTitle">1. Účel smernice</h1>
            <p >Účelom tejto internej smernice je detailne upraviť procesy, princípy a štandardy riadenia kvality vzdelávania poskytovaného spoločnosťou <strong>Poradca podnikateľa, s. r. o.,</strong> prostredníctvom platformy <strong>Profivzdelávanie.sk</strong>. Dokument predstavuje základný pilier systému riadenia kvality a stanovuje jednotný rámec, ktorý zabezpečuje transparentnosť, odbornú úroveň, právnu bezchybnosť a vysokú používateľskú hodnotu vzdelávacích výstupov.</p>
            <h1 className="sectionTitle">2. Pôsobnosť smernice</h1>
            <p >Táto smernica sa vzťahuje na všetky osoby, ktoré sa podieľajú na plánovaní, príprave, realizácii, administrácii alebo hodnotení vzdelávacích aktivít v rámci platformy <strong>Profivzdelávanie.sk </strong>v spoločnosti <strong>Poradca podnikateľa, s. r. o.</strong>, úsek Vzdelávanie. Pôsobnosť smernice sa vzťahuje nielen na interných zamestnancov, ale aj na externých spolupracovníkov, ktorí vykonávajú odbornú, technickú alebo zákaznícku podporu.</p>
            <p >Smernica sa uplatňuje pri všetkých druhoch vzdelávacích aktivít, pričom každá forma má svoje špecifiká, ktoré musia byť zohľadnené pri plánovaní, realizácii aj vyhodnocovaní:</p>
            <ul  >
                <li  ><strong>online kurzy a videokurzy</strong> – obsahujú vopred pripravený audiovizuálny materiál, ktorý musí spĺňať technické a didaktické štandardy,</li>
                <li  ><strong>webináre/online školenia</strong> – synchrónna forma vzdelávania, ktorá si vyžaduje dôslednú technickú prípravu a riadenie interakcie s účastníkmi,</li>
                <li  ><strong>prezenčné školenia</strong> – zamerané na priamu prácu s účastníkmi, s dôrazom na bezpečnosť, didaktiku a organizačnú pripravenosť,</li>
                <li  ><strong>odborné konferencie</strong> – viaczdrojové podujatia, na ktorých musí byť zabezpečená odborná garancia všetkých blokov,</li>
                <li  ><strong>hybridné formy vzdelávania</strong> – kombinácia prezenčnej a online formy, ktorá vyžaduje zvýšenú koordináciu technických a organizačných prvkov.</li>
            </ul>
            <h1 className="sectionTitle">3. Definície pojmov</h1>
            <h2 className="sectionTitle">3.1 Vzdelávacia aktivita</h2>
            <p >Vzdelávacia aktivita je odborný program určený na vzdelávanie dospelých, rozvoj pracovných kompetencií alebo prehlbovanie kvalifikácie. Obsah musí byť vypracovaný tak, aby zodpovedal legislatívnym požiadavkám a aktuálnemu stavu poznania.</p>
            <h2 className="sectionTitle">3.2 Kvalita vzdelávania</h2>
            <p >Kvalita vzdelávania predstavuje súbor parametrov, ktorými sa hodnotí celková úroveň poskytovaného vzdelania. Zahŕňa odbornú presnosť, legislatívnu správnosť, technickú kvalitu, didaktickú vhodnosť, používateľskú prístupnosť a celkovú pridanú hodnotu pre účastníka.</p>
            <h2 className="sectionTitle">3.3 Odborný garant</h2>
            <p >Odborný garant je osoba, ktorá zodpovedá za odborný dohľad nad obsahom vzdelávacích programov. Jeho úlohou je garantovať, že obsah je nielen legislatívne správny, ale aj odborne aktuálny, metodicky správne vystavaný a vhodný pre cieľovú skupinu.</p>
            <h2 className="sectionTitle">3.4 Lektor</h2>
            <p >Lektor je odborník poverený prípravou a prezentovaním vzdelávacieho obsahu. Musí mať schopnosť prenášať odborné informácie zrozumiteľným spôsobom, využívať didaktické metódy vhodné pre vzdelávanie dospelých a zároveň rešpektovať všetky interné štandardy.</p>
            <h2 className="sectionTitle">3.5 Účastník</h2>
            <p >Účastníkom je osoba, ktorá absolvuje vzdelávaciu aktivitu. Jeho spätná väzba je významným prvkom procesu skvalitňovania vzdelávania a je systematicky vyhodnocovaná.</p>
            <h2 className="sectionTitle">3.6 Evaluácia</h2>
            <p >Evaluácia predstavuje systematické hodnotenie kvality vzdelávacej aktivity. Cieľom evaluácie je získať údaje o spokojnosti účastníkov, didaktickej úrovni, odbornosti lektora, technickej kvalite a prínosoch programu.</p>
            <h1 className="sectionTitle">4. Zodpovednosti</h1>
            <h2 className="sectionTitle">4.1 Odborný garant</h2>
            <p >Odborný garant je odbornou autoritou pre jednotlivé oblasti vzdelávania. Jeho úloha presahuje rámec formálneho schvaľovania obsahu – je garantom odbornosti, metodiky a kvalitatívnej úrovne. Garant:</p>
            <ul  >
                <li  >zabezpečuje odbornú presnosť obsahu v súlade s právnymi predpismi,</li>
                <li  >aktívne monitoruje legislatívne zmeny a vyhodnocuje ich dosah na obsah kurzov,</li>
                <li  >poskytuje lektorom metodické vedenie a odborné odporúčania,</li>
                <li  >zodpovedá za to, že obsah je vystavaný podľa zásad andragogiky a didaktiky dospelých,</li>
                <li  >vedie záznamy o všetkých kontrolách a odporúčaniach na úpravy obsahu.</li>
            </ul>
            <p >Odborný garant musí spĺňať:</p>
            <ul  >
                <li  >vysokoškolské vzdelanie II. stupňa v odbore relevantnom pre obsah alebo minimálne 3 roky odbornej praxe,</li>
                <li  >bezúhonnosť (preukázaná čestným vyhlásením),</li>
                <li  >udržiavať odbornú zdatnosť pravidelným štúdiom.</li>
            </ul>

            <h2 className="sectionTitle">4.2 Lektor</h2>
            <p >Lektor je odborná a komunikačná opora vzdelávania. Okrem samotnej prezentácie má povinnosť:</p>
            <ul  >
                <li  >pripravovať obsah, ktorý je odborne správny, zrozumiteľný, v súlade s legislatívou a Autorským zákonom,</li>
                <li  >v prípade vzdelávacích programov pravidelne konzultovať obsah s garantom najmä pri legislatívnych zmenách,</li>
                <li  >reagovať na hodnotenia účastníkov a zapracovať odporúčania,</li>
                <li  >dodržiavať stanovené technické štandardy pre prezentácie a videá,</li>
                <li  >zabezpečiť, aby všetky informácie boli podávané objektívne, vecne a v súlade s odbornou etikou,</li>
                <li  >udržiavať odbornú zdatnosť pravidelným štúdiom.</li>
            </ul>

            <h2 className="sectionTitle">4.3 Projektový manažér</h2>
            <p >Projektový manažér je organizačným garantom procesu vzdelávania. Jeho úlohou je zabezpečiť hladký priebeh všetkých fáz vzdelávacej aktivity. Zodpovedá najmä za:</p>
            <ul  >
                <li  >koordináciu interných a externých spolupracovníkov,</li>
                <li  >logistiku, technické zabezpečenie a komunikáciu s účastníkmi,</li>
                <li  >evidenciu všetkých dokumentov súvisiacich s obsahom, schváleniami, hodnoteniami a aktualizáciami,</li>
                <li  >vyhodnocovanie rizík a návrh nápravných opatrení.</li>
            </ul>
            <h2 className="sectionTitle">4.4 Technická podpora</h2>
            <p >Technická podpora zabezpečuje technickú kvalitu vzdelávania a rieši technické problémy v reálnom čase. Zahŕňa najmä:</p>
            <ul  >
                <li  >kontrolu kvality obrazu, zvuku a funkčnosti platformy,</li>
                <li  >prípravu technických podkladov pre webináre/online školenia a videokurzy,</li>
                <li  >archiváciu záznamov a ich bezpečné uloženie,</li>
                <li  >riešenie technických komplikácií počas vysielania.</li>
            </ul>
            <h2 className="sectionTitle">4.5 Zákaznícky servis</h2>
            <p >Zákaznícka podpora plní dôležitú úlohu v oblasti komunikácie s účastníkmi. Zodpovedá za:</p>
            <ul>
                <li>profesionálne informovanie,</li>
                <li>riešenie otázok,</li>
                <li>prijímanie podnetov a ich smerovanie na príslušné osoby.</li>
            </ul>
            <p >Zároveň zabezpečuje, aby účastníci dostali všetky potrebné údaje včas a v zrozumiteľnej forme.</p>
            <h1 className="sectionTitle">5. Proces zabezpečovania kvality</h1>
            <h2 className="sectionTitle">5.1 Plánovanie vzdelávania</h2>
            <p >Plánovanie je strategická fáza, ktorá určuje smerovanie celej vzdelávacej aktivity. V tejto fáze sa identifikujú potreby trhu, hodnotí konkurencia, zisťuje dopyt a sledujú legislatívne zmeny. Výber tém vychádza z:</p>
            <ul  >
                <li  >analýzy potrieb cieľových skupín,</li>
                <li  >požiadaviek legislatívy,</li>
                <li  >trendov v oblasti podnikania, práva, personalistiky a ekonomiky,</li>
                <li  >spätnej väzby účastníkov predchádzajúcich programov, online školení, webinárov, videokurzov, odborných konferencií.</li>
            </ul>
            <h2 className="sectionTitle">5.2 Tvorba obsahu</h2>
            <p >Tvorba obsahu musí byť systematická, odborná a metodicky správna. Obsah je vytváraný v súlade so zásadami didaktiky dospelých a musí byť jasne štruktúrovaný. Obsah musí obsahovať:</p>
            <ul  >
                <li  >jasne definované ciele vzdelávania,</li>
                <li  >logickú nadväznosť tém, príkladov a výkladov,</li>
                <li  >praktické príklady a aplikačné ukážky,</li>
                <li  >zoznam legislatívnych zdrojov alebo prelinkovanie na zdroje v online prezentačných materiáloch.</li>
            </ul>
            <h2 className="sectionTitle">5.3 Realizácia vzdelávania</h2>
            <p >Realizácia je vykonávacou fázou procesu a zahŕňa:</p>
            <ul  >
                <li  >moderovanie podujatia,</li>
                <li  >aktívne riadenie interakcie s účastníkmi,</li>
                <li  >zabezpečenie technicky bezchybného priebehu,</li>
                <li  >riešenie krízových situácií (napr. výpadok techniky, výpadok internetového pripojenia lektora a pod.),</li>
                <li  >udržiavanie didaktickej a odbornej kvality počas celej aktivity.</li>
            </ul>
            <h2 className="sectionTitle">5.4 Hodnotenie kvality (Evaluácia)</h2>
            <p >Evaluácia je dôležitou súčasťou kvality. Systematicky sa zbierajú údaje od účastníkov, lektorov aj technického tímu. Dotazníky hodnotia:</p>
            <ul  >
                <li  >odbornú úroveň lektora,</li>
                <li  >jasnosť výkladu,</li>
                <li  >prínos obsahu pre prax,</li>
                <li  >technickú kvalitu,</li>
                <li  >celkovú spokojnosť.</li>
            </ul>
            <p >Výsledky evaluácie sa následne premietajú do plánu aktualizácií alebo korekčných opatrení minimálne <strong>raz ročne</strong>.</p>
            <h1 className="sectionTitle">6. Riadenie zmien a aktualizácií</h1>
            <p >Riadenie zmien je súčasťou kvalitného vzdelávania. Vzhľadom na dynamickosť legislatívy aj praxe je potrebné obsah pravidelne upravovať:</p>
            <ul  >
                <li  >obsah kurzov sa pravidelne monitoruje a aktualizuje minimálne <strong>raz ročne</strong>,</li>
                <li  >legislatívne kurzy sa aktualizujú vždy pri zmene relevantnej legislatívy,</li>
                <li  >projektový manažér zabezpečuje záznam o všetkých vykonaných aktualizáciách,</li>
                <li  >aktualizácie vzdelávacích programov podliehajú schváleniu odborného garanta.</li>
            </ul>
            <h1 className="sectionTitle">7. Evidencia a dokumentácia</h1>
            <p >Evidencia je vedená v internom systéme PP a musí byť úplná, presná a bezpečne uložená. Dokumentácia (obsahy kurzov, zmenové záznamy, hodnotenia) je základným zdrojom pre interné audity a kontroly. Prístup k dokumentom je riadený podľa interných právomocí.</p>
            <h1 className="sectionTitle">8. Podpora účastníkov a riešenie podnetov</h1>
            <p >Podpora účastníkov je dôležitým prvkom kvality. Každý účastník má právo na profesionálnu a včasnú odpoveď na otázky či podnety:</p>
            <ul  >
                <li  >účastníci môžu podávať podnety prostredníctvom e-mailu, formulára či telefonicky,</li>
                <li  >podnety sa evidujú a riešia v lehote do <strong>5 pracovných dní</strong>.</li>
            </ul>
            <p >V prípade sťažností manažér služieb zákazníkom vykoná analýzu, navrhne riešenie a informuje zúčastnené strany.</p>
            <h1 className="sectionTitle">9. Kontrola dodržiavania smernice</h1>
            <p >Dodržiavanie smernice sa pravidelne kontroluje interným auditom. Audit posudzuje procesy, dokumenty, záznamy a výsledky školení:</p>
            <ul  >
                <li  >kontrolu vykonáva poverená osoba z vedenia spoločnosti,</li>
                <li  >minimálne raz ročne sa uskutoční interný audit kvality vzdelávania,</li>
                <li  >zistenia auditu sa dokumentujú a prijímajú sa nápravné opatrenia.</li>
            </ul>




        </Wrapper>
    );
};

export default EducationQualityManagementSystemTemplate;
